export const cigarreras = {
	nombre: "Cigarreras",
	dia: "Miércoles Santo",
	nombrecompleto:
		"Real, Ilustre y Venerable Cofradía de Penitencia de Nuestro Padre Jesús de la Salud, María Santísima de la Esperanza y Nuestra Señora del Amor Hermoso",
	sede: "Iglesia Conventual de Santo Domingo",
	pasos: 2,
	distancia: [912, 1590],
	penitentes: 225,
	cargadores: 88,
	web: "http://www.diariodecadiz.es/semana_santa/Cigarreras_0_1229277827.html",

	ida: [
		{ lng: -6.2900812, lat: 36.5288521 },
		{ lng: -6.2902361, lat: 36.529017 },
		{ lng: -6.2901369, lat: 36.5291074 },
		{ lng: -6.2912687, lat: 36.5296936 },
		{ lng: -6.2911132, lat: 36.5298381 },
		{ lng: -6.291081, lat: 36.5299631 },
		{ lng: -6.2918159, lat: 36.530489 },
		{ lng: -6.2919165, lat: 36.53042 },
		{ lng: -6.2926535, lat: 36.5312519 },
		{ lng: -6.2929143, lat: 36.5310903 },
		{ lng: -6.2922169, lat: 36.5302907 },
		{ lng: -6.2928177, lat: 36.5297928 },
		{ lng: -6.293043, lat: 36.5298165 },
		{ lng: -6.2932684, lat: 36.5297389 },
		{ lng: -6.2936144, lat: 36.5297055 },
		{ lng: -6.2945504, lat: 36.5296344 },
		{ lng: -6.2946309, lat: 36.5295374 },
		{ lng: -6.2950721, lat: 36.5296193 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956595, lat: 36.5290773 },
		{ lng: -6.2954262, lat: 36.5297562 },
		{ lng: -6.2956703, lat: 36.5299609 },
		{ lng: -6.2952867, lat: 36.5303316 },
		{ lng: -6.2950131, lat: 36.5308338 },
		{ lng: -6.2949246, lat: 36.5308446 },
		{ lng: -6.2949327, lat: 36.5314567 },
		{ lng: -6.2964226, lat: 36.5317907 },
		{ lng: -6.2964213, lat: 36.5318834 },
		{ lng: -6.2967807, lat: 36.5325558 },
		{ lng: -6.2964481, lat: 36.5329093 },
		{ lng: -6.2962684, lat: 36.5332369 },
		{ lng: -6.2963489, lat: 36.5333015 },
		{ lng: -6.2962724, lat: 36.5339309 },
		{ lng: -6.2954637, lat: 36.5340192 },
		{ lng: -6.2922639, lat: 36.530295 },
		{ lng: -6.2913224, lat: 36.5296829 },
		{ lng: -6.2901772, lat: 36.5291031 },
		{ lng: -6.2902844, lat: 36.5290126 },
		{ lng: -6.290094, lat: 36.5288337 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-28T18:00",
			latlng: [36.5288, -6.29012]
		},
		{
			name: "Nueva",
			hora: "2018-03-28T19:35",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-28T20:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-28T21:35",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-28T22:10",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-28T22:25",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Compás de Santo Domingo",
			"Plocia",
			"Callejón de los Negros",
			"Lázaro Dou",
			"Plaza San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza de San Juan de Dios",
			"Plocia",
			"Compás de Santo Domingo"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/cigarreras.js